// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"200c6b13","239":"bf15bca1","436":"6bd5b8f2","455":"eb4727e3","776":"fc585d5e","958":"26c885b9"}[chunkId] + ".chunk.js";
};